import React from "react";

const PanelBlock = ({ data, type }) => {
  const resultOpen = data?.result_open;
  const resultClose = data?.result_close;

  return (
    <td className="py-5 border-2 border-blue-700">
      <div className={`flex items-center ${type=="panel" ? 'justify-between': "justify-center"}`}>
        { type == 'panel' ? <div>
          <ul className="flex flex-col gap-1 p-1">
            <li>{resultOpen?.[0] || "*"}</li>
            <li>{resultOpen?.[1] || "*"}</li>
            <li>{resultOpen?.[2] || "*"}</li>
          </ul>
        </div> : <></> }
        <div>
          <h2 className="text-red-700 text-3xl">
            {resultOpen?.[4] || "*"}
            {resultClose?.[0] || "*"}
          </h2>
        </div>
        {type=='panel' ? <div>
          <ul className="flex flex-col gap-1 p-1">
            <li>{resultClose?.[2] || "*"}</li>
            <li>{resultClose?.[3] || "*"}</li>
            <li>{resultClose?.[4] || "*"}</li>
          </ul>
        </div> : <></> }
      </div>
    </td>
  );
};

export default PanelBlock;
